<template>
  <div id="player" >
    <van-row type="flex" align="center" >
      <van-col span="13" >
        <van-search
          placeholder="请输入关键字"
          shape="round"
          v-model="search"
          @change="onSearch"
          @search="onSearch"
          @cancel="onCancel">
        </van-search>
      </van-col>
      <van-col span="11" >
        <!--<van-radio-group v-model="keyWord">
          <van-radio name="id">编号</van-radio>
          <van-radio name="trueName">姓名</van-radio>
          <van-radio name="certificateNum">证件号</van-radio>
        </van-radio-group>-->
        <van-tabs v-model="keyWord" >
          <!--<van-tab title="编号"></van-tab>-->
          <van-tab title="姓名"></van-tab>
          <van-tab title="证件号"></van-tab>
        </van-tabs>
      </van-col>
    </van-row>
    <van-row>
      <van-col span="23" style="text-align: right;">
<!--        <span style="font-size: 14px;padding-left: 24px;">共{{totalCount}}条</span>-->
        <van-button size="mini" type="primary" @click="exportData()" >导出</van-button>
        <van-button size="mini" type="default" @click="selectAll()" >{{selectedPlayers.length === 0 || (selectedPlayers.length != list.length) ? '全选': '反选'}}</van-button>
        <van-button size="mini" type="default" @click="openPopup()" >确认</van-button>
      </van-col>
    </van-row>
    <div class="block" >
      <van-checkbox-group v-model="selectedPlayers">
        <div class="title">
          <van-row class="row-checkbox" type="flex" align="center">
            <van-col span="4" >姓名</van-col>
            <van-col span="3" >性别</van-col>
            <van-col span="3" >生日</van-col>
            <van-col span="3" >位置</van-col>
            <van-col span="6" >证件号</van-col>
            <van-col span="3" >状态</van-col>
            <van-col span="3" >操作</van-col>
          </van-row>
        </div>
        <div class="main" >
          <van-list>
            <van-cell v-for="item in list" :key="item.id" >
              <van-row class="row-checkbox" type="flex" align="center">
                <van-col span="4" >{{item.trueName}}</van-col>
                <van-col span="3" >{{item.gender}}</van-col>
                <van-col span="3" >{{formatDate(item.birthday)}}</van-col>
                <van-col span="3" >{{item.position}}</van-col>
                <van-col span="6" >{{item.certificateNum}}</van-col>
                <van-col span="3">
                  <div @click="openPopup(item)">
                    {{formatStatus(item.status)}}
                  </div>
                </van-col>
                <van-col span="3" >
                  <van-checkbox :name="item" checked-color="#185494" />
                </van-col>
              </van-row>
            </van-cell>
          </van-list>
        </div>
      </van-checkbox-group>
      <van-row>
        <van-col span="4">
          <div style="font-size: 16px;padding-top: 10px;">
            共{{totalCount}}条
          </div>
        </van-col>
        <van-col span="20">
          <van-pagination
            v-model="currentPage"
            :total-items="totalCount"
            :page-count="pageCount"
            @change="getPlayerList"
            mode="simple"
          />
        </van-col>
      </van-row>

      <van-popup v-model="isShowPopup" position="bottom" :overlay="true">
        <van-picker show-toolbar :columns="auditList" value-key="label" @change="onChange" @cancel="onPopCancel" @confirm="onConfirm" ></van-picker>
      </van-popup>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import { getPlayerList, exportOrganizationPlayers, updateOrganizationPlayerStatus } from '@/api/member'
import { Search, List, Row, Col, Tab, Tabs, Pagination, Toast } from 'vant'
Vue.use(Search).use(List).use(Row).use(Col).use(Tab).use(Tabs).use(Pagination).use(Toast)

export default {
  name: 'ShowPlayer',
  data() {
    return {
      list: [],
      orgId: '',
      currentPage: 1,
      pageSize: 50,
      totalCount: 0,
      pageCount: 0,
      keyWord: 0,
      search: '',
      loading: false,
      finished: true,
      error: false,
      isShowPopup: false,
      player: {},
      auditList: [],
      selectedPlayers: []
    }
  },
  created () {
    this.orgId = this.$route.query && this.$route.query.orgId
    this.getPlayerList()
    this.auditList = [
      { value: 0, label: '待确认' },
      { value: 2, label: '接收' },
      { value: 1, label: '退回' }]
  },
  mounted () {},
  methods: {
    onLoad() {
      let key = ['trueName', 'certificateNum']
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        organizationId: this.orgId
      }
      params[key[this.keyWord]] = this.search
      getPlayerList(params).then(response => {
        const data = response.data
        if (data) {
          // 处理数据
          this.list = data.list
          // 处理分页
          this.currentPage = data.pageNum
          this.totalCount = data.count
          this.loading = false
        }
      })
    },

    getPlayerList() {
      let key = ['trueName', 'certificateNum']
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        organizationId: this.orgId
      }
      params[key[this.keyWord]] = this.search
      getPlayerList(params).then(response => {
        const data = response.data
        if (data) {
          this.list = data.list
          this.currentPage = data.pageNum
          this.totalCount = data.count
          this.pageCount = Math.ceil(data.count/this.pageSize)
        }
      })
    },
    onSearch() {
      this.getPlayerList()
    },
    onCancel() {
    },
    selectAll () {
      if (this.selectedPlayers.length === this.list.length) {
        this.selectedPlayers = []
      } else {
        this.selectedPlayers = this.list
      }
    },
    exportData() {
      const params = {
        organizationId: this.orgId
      }
      exportOrganizationPlayers(params).then(response => {
        const data = response.data
        if(data && data.email) {
          Toast('导出成功，请至邮箱：' + data.email + '查收')
        }
      })
    },
    onConfirm(value, index) {
      // API请求更新审核状态，API返回后执行
      if (this.selectedPlayers.length === 0) {
        Toast('至少选择一名球员')
        return
      }
      const playerIds = this.selectedPlayers.map(item => item.id).join()
      const params = {
        organizationId: this.orgId,
        playerId: playerIds,
        status: value.value
      }
      updateOrganizationPlayerStatus(params).then(response => {
        const data = response.data
        if (data && data.update) {
          this.isShowPopup = false
          this.getPlayerList()
        }
      })
    },
    onChange() {
    },
    onPopCancel() {
      this.isShowPopup = false
    },
    openPopup(player) {
      this.isShowPopup = true
      if (player) {
        this.player = player
        this.selectedPlayers = [player]
      }
    },
    formatDate(date) {
      let ret = ''
      if (date) {
        ret = moment(date).format('YYYY-MM-DD')
      }
      return ret
    },
    formatStatus(status) {
      status = status || 0
      let obj = null
      for (let i=0; i<this.auditList.length; i++) {
        if (this.auditList[i].value === status ) {
          obj = this.auditList[i]
          break;
        }
      }
      return obj.label
    }
  }
}
</script>
<style lang="scss" >

#player {
  max-width: 768px; /*px*/
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: white;
}

#player {
  .title {
    height: 55px;
    line-height: 55px;
    .van-row {
      .van-col {
        padding: 0 5px;
      }
    }
  }
}

#player {
  .main {
    position: relative;
    width: 100%;
    padding: 0 15px;
    left: 0;
    /* height: calc(100% - 106px); */
    height: 470px;
    overflow: scroll;
    .van-list {
      .van-cell:not(:last-child)::after {
        border-color: transparent;
      }
      .van-cell:nth-child(odd) {
        background-color: #FAFAFA;
      }
      .van-cell {
        .van-col {
          word-break: break-all;
        }
      }
    }
  }
}

#player .block {
  padding: 0 15px;
}

#player .block .title{
  font-size: 14px; /*no*/
}

#player .van-cell:not(:last-child)::after {
  left: 0
}

#player .main {
  padding: 5px 0;
  /*border-bottom: 1px solid #ccc;*/
}

#player .main ul {
  display: flex;
}

#player .main ul li {
  flex: 1;
  text-align: left;
  font-size: 12px; /* no */
}

#player {
  .van-search {
    background-color: white;
    padding-right: 0;
    .van-search__content {
      background-color: white;
      border: 1px solid rgba(230,230,230,1);
      height: 45px;
      border-radius: 45px;
      line-height: 45px;
      .van-cell {
        .van-field__left-icon {
          display: flex;
          align-items: center;
          .van-icon {
            font-size: 28px;
            color: #979797;
          }
        }
        .van-cell__value {
          display: flex;
          align-items: center;
          color: #E2E2E2;
          font-size: 14px;
          .van-field__body {
            width: 100%;
          }
        }
      }
    }
  }
  .van-search {

  }
  .van-tabs {
    .van-hairline--top-bottom::after {
      border-width: 0;
    }
    .van-tabs__line {
      background-color: #185494;
    }
    .van-tab--active {
      font-weight:500;
      color:rgba(24,84,148,1);
    }
    .van-tab {
      .van-ellipsis {
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/ucenter/show-player.vue